import $ from "jquery";
import Swup from "swup";

import { detect_touch } from "./modules/detect-touch";
import { setup_page, home_animation, setup_infopanel } from "./modules/page";
import { setup_sliders } from './modules/sliders';
import { update_aria, setup_menu  } from "./modules/menu";
import { setup_transitions } from "./modules/swup";
import { setup_map } from "./modules/map";

$(document).ready(function() {

    // Setup transitions
    setup_transitions();

    // Menus
    setup_menu();

    if (document.querySelector("body.home") != null)
    {
        home_animation();
    }

    function init() {

        // Detects if touch device
        detect_touch();

        // Setup page - scrolled?
        setup_page();

        // Check current page
        update_aria();

        if (document.querySelector("body.contact") != null)
        {
            setup_map();
        }

        if (document.querySelector("body.single") != null)
        {
            setup_sliders();
            setup_infopanel();
        }

    }

    init();

    document.addEventListener("swup:contentReplaced", init);
    document.addEventListener("swup:animationInDone", function(e){
      let forms = $('.module-content__inner');
      forms.find('script').each(function(){
        let code = $(this).html();
        eval(code);
      });
    });


    //Back button fix
    window.addEventListener('popstate', function(event) {
      if (event.state) {
        // Setup transitions
        setup_transitions();

        // Menus
        setup_menu();

        if (document.querySelector("body.home") != null)
        {
          home_animation();
        }

        init();
      }
    }, false);

});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js